<template>
    <div class="loyalty-card">

        <div class="content" :class="{open:open, closed:!open}">
            <svg
                viewBox="0 0 100 100"
                class="gradient"
                width="100%"
                height="100%"
                preserveAspectRatio="none"
            >
                <defs>
                    <linearGradient id="Gradient2">
                    <stop offset="0%" stop-color="rgba(82, 48, 138, 1)" />
                    <stop offset="100%" stop-color="rgba(143, 83, 240, 1)" />
                    </linearGradient>
                </defs>
                <path d="M 0 60, A 100 40 0 0 0 100 50 , L 100 100,L 0 100, Z" fill="url('#Gradient2')"></path>
            </svg>
            <div class="qr-wrapper"><QrCode :url="t('loyalty_avolta_link')"></QrCode></div>
            <div class="text">
                <div class="top">{{t('loyalty_become_a_member')}}</div>
                <div class="bottom"><div class="logo"></div></div>
            </div>
            <div class="close" @click="()=>open = !open"></div>
        </div>
    </div>
</template>
<script>
import QrCode from './QrCode.vue';

export default {
  props: [],
  components:{
    QrCode
  },
  data(){
    return {
        open: true
    }
  }
};
</script>
<style lang="stylus">
.loyalty-card
    position absolute
    top 0
    right 0
    margin vw(40px)
    width vw(230px)
    // height vw(320px)
    z-index 999
    interpolate-size: allow-keywords
    .content
        position: relative
        background-image: url("~../assets/images/banner_background.jpg")
        background-size: cover
        background-position: 50% 15%
        // height: 100%
        overflow: hidden
        border-radius vw(20px) 0 vw(20px) 0
        display flex 
        flex-direction column
        --arc-pos: vw(200px)
        &.closed
            .gradient
                height vw(380px)
            .qr-wrapper
                flex: 0 0 0px;
                padding: 0;
            .text
                padding-top vw(40px)
            .close
                &:after
                    transform: translate(-50%,-50%) rotate(-90deg)
        .gradient
            // background: rgba(143, 83, 240, 1)
            transition all .6s
            // clip-path: shape(from 0 100%, line to 0 var(--arc-pos) , arc to 100%  calc(var(--arc-pos)*0.8) of calc(var(--arc-pos)*1.6), line to 100% 100%, line to 0 100%)
            width: 100%
            height: vw(320px)
            position: absolute
            bottom 0
        
        .qr-wrapper
            interpolate-size: allow-keywords
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex 1 1 auto
            width vw(130px)
            margin auto
            padding-top vw(20px)
            transition all .6s
            overflow: hidden;
        .text
            
            flex 1 1 50%
            padding vw(20px)
            padding-top vw(80px)
            color #fff
            z-index 1
            display flex
            flex-direction  column
            transition all .6s
            gap vw(10px)
            .top    
                m-font-size(24,22)
                font-weight 600
            .bottom
                .logo
                    background-image: url('~../assets/images/club_avolta.svg')
                    background-repeat: no-repeat
                    background-size: contain
                    width: 100%
                    height: vw(30px)
                    margin-left vw(-5px)
         .close
            position: absolute
            top: 0
            right: 0
            background: #fff
            width: vw(25px)
            height: vw(25px)
            border-radius: vw(25px)
            margin: vw(10px)
            border: solid 1px rgba(143, 83, 240, 1)
            cursor: pointer
            z-index: 99
            &:after
                content: ''
                position: absolute
                transition transform .5s
                top: 50%
                left: 50%
                transform: translate(-50%,-50%) rotate(90deg)
                m-icon('back-black',15px,rgba(143, 83, 240, 1))
                
</style>